import { AsyncPipe } from '@angular/common';
import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { ReactiveFormsModule, UntypedFormBuilder, UntypedFormControl } from '@angular/forms';
import { PaneComponent } from '@rocksoft/cdk';

@Component({
  selector: 'ml-diagnostic-submission-ui',
  templateUrl: './diagnostic-submission.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PaneComponent, ReactiveFormsModule, AsyncPipe],
})
export class ManagedSettingsDiagnosticSubmissionComponent {
  private readonly fb = inject(UntypedFormBuilder);

  readonly diagnosticSubmission = output<boolean>();

  public readonly diagnosticSubmissionForm = this.fb.group({
    diagnosticSubmissionEnabled: [false],
  });

  get diagnosticSubmissionEnabled() {
    return this.diagnosticSubmissionForm.get('diagnosticSubmissionEnabled') as UntypedFormControl;
  }
  onSubmit() {
    this.diagnosticSubmission.emit(this.diagnosticSubmissionEnabled.value);
  }
}
